import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { UpsellModalComponent } from "src/app/components/upsell-modal/upsell-modal.component";
import { SharedModule } from "src/app/shared/shared.module";
import { BrandReviewsComponent } from "src/components/brand-reviews/brand-reviews";
import { UpsellButtonsComponent } from 'src/components/upsell-buttons/upsell-buttons';
import { UpsellFooterComponent } from "src/components/upsell-footer/upsell-footer";
import { UpsellGuaranteeComponent } from "src/components/upsell-guarantee/upsell-guarantee";
import { UpsellOfferSpinnerV2Component } from "src/components/upsell-offer-spinner-v2/upsell-offer-spinner-v2";
import { UpsellOfferSpinnerComponent } from 'src/components/upsell-offer-spinner/upsell-offer-spinner';
import { UpsellProductBoxFullComponent } from "src/components/upsell-product-box-full/upsell-product-box-full";
import { UpsellProductBoxComponent } from "src/components/upsell-product-box/upsell-product-box";
import { UpsellSectionComponent } from "src/components/upsell-section/upsell-section";
import { UpsellStepsComponent } from "src/components/upsell-steps/upsell-steps";
import { UpsellStickyBarV2 } from "src/components/upsell-sticky-bar-v2/upsell-sticky-bar-v2";
import { UpsellStickyBar } from "src/components/upsell-sticky-bar/upsell-sticky-bar";
import { UpsellWaitComponent } from "src/components/upsell-wait/upsell-wait";
import { UpsellWhyComponent } from "src/components/upsell-why/upsell-why";
import { SimpleVideoPlayerComponent } from "src/components/simple-video-player/simple-video-player";
import { VideoPlayerComponent } from "src/components/video-player/video-player";
import { UpsellHeaderComponent } from "src/components/upsell-header/upsell-header";
import { UpsellDisclaimerComponent } from 'src/components/upsell-disclaimer/upsell-disclaimer.component';
import { UpsellVideoComponent } from 'src/components/upsell-video/upsell-video';

@NgModule({
  declarations: [
    BrandReviewsComponent,
    SimpleVideoPlayerComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellGuaranteeComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    UpsellHeaderComponent,
    VideoPlayerComponent,
    UpsellDisclaimerComponent,
    UpsellVideoComponent    
  ],
  exports: [
    BrandReviewsComponent,
    SimpleVideoPlayerComponent,
    UpsellButtonsComponent,
    UpsellFooterComponent,
    UpsellGuaranteeComponent,
    UpsellModalComponent,
    UpsellOfferSpinnerComponent,
    UpsellOfferSpinnerV2Component,
    UpsellProductBoxComponent,
    UpsellProductBoxFullComponent,
    UpsellSectionComponent,
    UpsellStepsComponent,
    UpsellStickyBar,
    UpsellStickyBarV2,
    UpsellWaitComponent,
    UpsellWhyComponent,
    UpsellHeaderComponent,
    VideoPlayerComponent,
    UpsellDisclaimerComponent,
    UpsellVideoComponent
  ],
  imports: [CommonModule, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpsellModule { }